<template>
  <div>
    <transition name="fade" v-if="loading">
      <div

          class="inset-0 absolute z-50 bg-black bg-opacity-10 w-full"
      >
        <loader class="center-h-v" />
      </div>
    </transition>
    <div v-else>
      <div class="my-2">
        <ve-table
            v-if="employeeData.length"
            :columns="columns"
            :table-data="employeeData"
        />

      </div>

      <el-drawer
          :visible.sync="objectivesDrawer"
          direction="rtl"
          :title="selectedEmployeeName"
          size="90%"
          class="shadow-2xl border-l-4"
      >

        <div class="flex justify-between items-center mb-4 px-2">
          <div>
            <!-- Thematic Weight Feedback -->
            <div
                v-if="currentEmpTotalWeight === 100"
                class="bg-green-100 text-green-700 font-semibold px-4 py-2 rounded-lg"
            >
              Goals submitted correctly: 100% weight.
            </div>
            <div
                v-else-if="currentEmpTotalWeight < 100"
                class="bg-yellow-100 text-yellow-700 font-semibold px-4 py-2 rounded-lg"
            >
              Warning: Total weight below 100% ({{ currentEmpTotalWeight }}%).
            </div>
            <div
                v-else
                class="bg-red-100 text-red-700 font-semibold px-4 py-2 rounded-lg"
            >
              Error: Total weight exceeds 100% ({{ currentEmpTotalWeight }}%).
            </div>
          </div>
        </div>
        <el-tabs type="border-card" v-model="activeTab">
          <el-tab-pane
              v-for="(tab, index) in tabs"
              :key="index"
              :label="tab.name"
              :name="tab.name"
          >
            <goals :employeeObjectives="employeeObjectives" v-if="activeTab==='Goals'" :refreshObjectives="() => fetchEmployeeObjectives(selectedRow)" ></goals>
            <BehavioralAssessment :employeeNumber="employeeId" v-if="activeTab==='Behavioral Assessment'"  />
            <employee-reviews :employeeObjectives="employeeObjectives" v-if="activeTab==='Employee Reviews'"></employee-reviews>
            <manager-reviews :refreshObjectives="() => fetchEmployeeObjectives(selectedRow)" :employeeObjectives="employeeObjectives" v-if="activeTab==='Manager Review'"></manager-reviews>
            <joint-review  :refreshObjectives="() => fetchEmployeeObjectives(selectedRow)" :employeeObjectives="employeeObjectives" v-if="activeTab==='Joint Review'"></joint-review>
            <recommendation :reviewPeriod="currentPeriod.Id" :employeeNumber="employeeId" v-if="activeTab==='Recommendation'"></recommendation>
            <el-dialog :visible.sync="editModalVisible" title="Edit Objective">
              <div class="p-6 bg-white rounded-lg">
                <el-form :model="editForm" label-position="top" class="space-y-6">
                  <!-- Strategic Goal (Non-Editable) -->
                  <el-form-item label="Strategic Goal" class="text-gray-400">
                    <el-input
                        v-model="editForm.StrategicGoal"
                        class="w-full text-gray-400 cursor-not-allowed border border-gray-300 focus:ring-0 focus:border-gray-300 shadow-sm rounded-lg"
                        disabled
                    />
                  </el-form-item>

                  <!-- Goal Name -->
                  <el-form-item label="Goal Name">
                    <el-input
                        v-model="editForm.GoalName"
                        class="w-full border border-gray-300 focus:ring-indigo-500 focus:border-indigo-500 shadow-sm rounded-lg"
                    />
                  </el-form-item>

                  <div class="flex flex-col md:flex-row">
                    <!-- Start Date -->
                    <el-form-item label="Start Date" class="w-full">
                      <el-date-picker
                          v-model="editForm.StartDate"
                          type="date"
                          placeholder="Pick a start date"
                          :default-time="['00:00:00']"
                          class="w-full border p-2"
                      />
                    </el-form-item>

                    <!-- End Date -->
                    <el-form-item label="End Date" class="w-full">
                      <el-date-picker
                          v-model="editForm.EndDate"
                          type="date"
                          placeholder="Pick an end date"
                          :default-time="['00:00:00']"
                          class="w-full border p-2"
                      />
                    </el-form-item>
                  </div>

                  <!-- Goal Measure -->
                  <el-form-item label="Goal Measure">
                    <el-input
                        v-model="editForm.GoalMeasure"
                        class="w-full border shadow-sm rounded-lg"
                    />
                  </el-form-item>

                  <!-- Target -->
                  <el-form-item label="Target">
                    <el-input
                        v-model="editForm.Target"
                        class="w-full border shadow-sm rounded-lg"
                    />
                  </el-form-item>

                  <!-- Weight -->
                  <el-form-item label="Weight">
                    <el-input-number
                        v-model="editForm.Weight"
                        :min="0"
                        :max="100"
                        class="w-full border shadow-sm rounded-lg"
                    />
                  </el-form-item>

                  <!-- Description -->
                  <el-form-item label="Description">
                    <el-input
                        type="textarea"
                        row="15"
                        v-model="editForm.Description"
                        class="w-full border shadow-sm rounded-lg"
                    />
                  </el-form-item>
                </el-form>
              </div>

              <!-- Modal Footer -->
              <span
                  slot="footer"
                  class="flex justify-end space-x-4 px-6 py-3 bg-gray-50 border-t border-gray-200"
              >
            <el-button
                @click="editModalVisible = false"
                class="text-gray-600 hover:bg-gray-200 focus:ring border"
            >
              Cancel
            </el-button>
            <el-button
                type="warning"
                @click="submitEditForm"
                class="bg-primary hover:bg-primary-dark text-white shadow-md rounded-lg"
            >
              Submit
            </el-button>
          </span>
            </el-dialog>
          </el-tab-pane>
        </el-tabs>

      </el-drawer>
    </div>
  </div>
</template>

<script>
import decryptData from '@/utils/decrypt';
import axios from 'axios';
import { mapGetters } from 'vuex';
import Goals from './goals';
import EmployeeReviews from './employeeReviews'
import ManagerReviews from './managerReview'
import JointReview from './jointReview'
import Recommendation from './createRecommendation'
import Loader from "@/components/loader/loader.vue";
import BehavioralAssessment from "@/components/PerformanceReview/teamPerformance/behavioralAssessment";
export default {
  name: 'ObjectivesGoals',
  components:{
    BehavioralAssessment,
    Goals,
    EmployeeReviews,
    ManagerReviews,
    JointReview,
    Recommendation,
    Loader
  },
  data() {
    return {
      loading: false,
      employeeData: [], // For grouped data (employees and their objectives)
      viewDialog: false,
      selectedObjective: {}, // Stores the selected objective for the modal
      reviewPeriods: [],
      currentPeriod: null,
      employeeObjectives: [], // Stores the objectives for the selected employee
      objectivesDrawer: false, // Controls the visibility of the objectives sidebar
      selectedEmployeeName: '',
      activeTab:"Goals",
      employeeId:'',
      selectedRow:"",
      tabs: [
        { name: "Goals", component: "Goals" },
        { name: "Employee Reviews", component: "EmployeeReviews" },
        { name: "Manager Review", component: "ManagerReview" },
        {name:"Behavioral Assessment", component: "BehavioralAssessment"},
        { name: "Joint Review", component: "JointReview" },
        { name: "Recommendation", component: "Recommendation" },
        { name: "Report", component: "Report" },
      ],
      columns: [
        {
          field: "Employee No.", key: "a", title: "Employee No.", align: "left",
          renderBodyCell: ({ row }) => (
              <p class="capitalize">{row.EmployeeNo}</p>
          ),
        },
        {
          field: "Employee Name",
          key: "b",
          title: "Employee Name",
          align: "left",
          renderBodyCell: ({ row }) => (
              <p class="capitalize">{row.EmployeeName}</p>
          ),
        },
        {
          field: "Total Goals",
          key: "goals",
          title: "Total Goals",
          align: "center",
          renderBodyCell: ({ row }) => (row.TotalGoals),
        },
        {
          field: "Total Weight",
          key: "c",
          title: "Total Weight",
          align: "center",
          renderBodyCell: ({ row }) =>
              (row.TotalWeight)
        },


        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
              <span class="underline text-blue-800 cursor-pointer" onClick={() => this.fetchEmployeeObjectives(row)}>View</span>

          ),
        },
      ],
      editModalVisible: false,
      editForm: {
        StrategicGoal: '',
        GoalName: '',
        StartDate: '',
        EndDate: '',
        GoalMeasure: '',
        Target: '',
        Weight: '',
        Description: '',
      },
    };
  },

  created() {
    this.getPerformancePeriodSetups();
  },

  methods: {
    setTab(tabName){
      alert(tabName)
      this.activeTab=tabName
    },
    setCurrentPeriod() {
      this.getObjectives();
      if (!this.currentPeriod) {
        console.log('No current period found.');
      }

    },
    getPerformancePeriodSetups() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {

              this.reviewPeriods = response.data.Data;
              this.currentPeriod = response.data.Data.find(
                  (period) => period.Active == true
              );
              this.setCurrentPeriod();
            } else {
              this.$notify.error({
                title: 'Failure',
                message: response.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: 'Failure', message: error.message });
          }
      );
    },

    async getObjectives() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      try {
        const response = await axios.get(
            `${this.getOrganization}/performance/objective/team/${this.$ApiVersion}/request?periodId=${this.currentPeriod.Id}`,
            options
        );
        if (response.status >= 200 && response.status < 300) {
          const objectives = response.data.Data;
          objectives.forEach((objective) => {
            const decryptedName = decryptData(
                objective.EmployeeName,
                this.$decryptionKey
            );
            objective.EmployeeName = decryptedName;
          });

          this.employeeData = objectives;
        } else {
          this.$notify.error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        this.$notify.error(`Error fetching data: ${error}`);
      } finally {
        this.loading = false;
      }
    },

    // Method to handle row expansion
    handleExpand(row, expandedRows) {
      expandedRows;
      // console.log('Row expanded:', row);
    },

    openViewModal(row) {
      // Check if objectives exist
      if (row && row.length > 0) {
        // Choose the first objective or modify this logic based on your needs
        this.selectedObjective = row;
        this.viewDialog = true;
      } else {
        this.$notify.warning('No objectives found for this employee.');
      }
    },

    hasWarnings(totalWeight) {
      return totalWeight < 100 || totalWeight > 100;
    },

    getWeightClass(totalWeight) {
      const tw = parseFloat(totalWeight);
      if (tw < 100) {
        return 'text-warning'; // Use a CSS class to apply warning styling
      } else if (tw > 100) {
        return 'text-danger'; // Use a CSS class to apply danger styling
      } else if (tw === 100) {
        return 'text-success'; // Use a CSS class to apply success styling
      }
      return '';
    },

    // Truncate the description text to a single line
    truncateText(text) {
      return text.length > 15 ? text.substring(0, 15) + '...' : text;
    },

    // Format ISO date into a readable format
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString(); // Customize format as needed
    },

    // Fetch employee objectives and open the sidebar
    async fetchEmployeeObjectives(row) {

      console.log(row)
      this.selectedRow=row
      this.employeeId=row.EmployeeId
      this.selectedEmployeeName = `${row.EmployeeNo} ${row.EmployeeName}`;
      try {
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },
        };

        // Send GET request with employeeId and currentPeriod.Id
        const response = await axios.get(
            `${this.getOrganization}/performance/objective/employee/${this.$ApiVersion}/request`,
            {
              params: {
                employeeId: row.EmployeeId,
                periodId: this.currentPeriod.Id,
              },
              ...options,
            }
        );
        if (response.status === 200) {
          this.employeeObjectives = response.data.Data;
          this.objectivesDrawer = true; // Open the sidebar
        } else {
          this.$notify.error('Failed to fetch objectives.');
        }
      } catch (error) {
        this.$notify.error(
            'Error fetching employee objectives: ' + error.message
        );
      }
    },

    handleAction(row, action) {
      if (action === 'edit') {
        this.openEditModal(row);
      } else if (action === 'delete') {
        this.deleteObjective(row);
      }
    },
    openEditModal(row) {
      // Populate the edit form with selected row data

      // Populate the edit form with the data from the selected objective
      this.editForm = {
        ...row,
        StartDate: row.StartDate, // Convert to Date object
        EndDate: row.EndDate, // Convert to Date object
      };

      this.editModalVisible = true;
    },
    submitEditForm() {
      // Handle form submission logic here
      // console.log('Submitting edited objective:', this.editForm);
      this.editModalVisible = false;

      this.loading = true;

      // Construct the URL with organization and API version
      const url = `${this.getOrganization}/performance/objective/${this.$ApiVersion}/edit`;

      // Prepare the payload for the PUT request
      const payload = {
        ObjectiveId: this.editForm.ObjectiveId,
        StrategicGoalId: this.editForm.StrategicGoalId, // If provided by your form
        GoalName: this.editForm.GoalName,
        StartDate: this.editForm.StartDate, // Convert to ISO string
        EndDate: this.editForm.EndDate, // Convert to ISO string
        GoalMeasure: this.editForm.GoalMeasure,
        Target: this.editForm.Target,
        Description: this.editForm.Description,
        Weight: this.editForm.Weight,
      };

      // Axios options including Authorization token
      const options = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.getToken}`, // Authorization token
        },
      };

      // Send the PUT request
      axios
          .put(url, payload, options)
          .then((response) => {
            this.loading = false; // Stop loading indicator
            // console.log(response);
            if (response.data.StatusCode === 200) {
              // Show success notification

              this.$notify({
                title: 'Success',
                message: 'Objective updated successfully!',
                type: 'success',
              });
              this.editModalVisible = false; // Close modal
              this.objectivesDrawer = false;
              this.fetchEmployeeObjectives(); // Refresh objectives if needed
            } else {
              this.$notify.error({
                title: 'Failure',
                message: response.data.StatusMessage,
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error('Error updating objective:', error);
            this.$notify.error({
              title: 'Error',
              message:
                  'There was an issue updating the objective. Please try again.',
            });
          });
    },

    // Methods for edit and delete actions on objectives
    editObjective() {
      // Add logic for editing the objective
      // console.log('Edit objective:', objective);
    },

    deleteObjective() {
      // Add logic for deleting the objective
      // console.log('Delete objective:', objective);
    },
  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken']),

    // Calculate total weight of all goals
    currentEmpTotalWeight() {
      return this.employeeObjectives.reduce((sum, obj) => sum + obj.Weight, 0);
    },
  },
};
</script>

<style scoped>
.el-icon-more {
  cursor: pointer;
}

/* Styling for different warning states */
.text-warning {
  color: #e6a23c; /* Warning color */
}

.text-danger {
  color: #f56c6c; /* Danger color */
}

.text-success {
  color: #67c23a; /* Success color */
}

.warning-message {
  margin-top: 10px; /* Space between messages */
}
</style>
